import {colors} from 'shells/colors/colors';
// @ts-expect-error
import {UpgradeArrowIcon} from 'shells/icon/svg/upgrade-arrow-icon';

import {appHistory} from '../../../../../history';

import {Button} from '../button/button';
import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

import {Card} from './card';

import styles from './phone-integration-card.module.css';

interface Props {
    icon: React.ReactNode;
    title: string;
    body: string | React.ReactNode;
    onClick?: () => void;
    requiresUpgrade?: boolean;
}

export function PhoneIntegrationCard(props: Props) {
    return (
        // @ts-expect-error
        <Card hasBorder={true} isFullWidth={true} hasShadow={true} fitHeight={true}>
            <div className={styles['phone-integration-card']}>
                {props.icon}
                <div className='flex flex-dir-col justify-sb full-height full-width gap-16'>
                    <Stack spacing={2}>
                        <div className='flex gap-8 align-center'>
                            <Body isBold={true} color='dark'>
                                {props.title}
                            </Body>
                            {props.requiresUpgrade && (
                                <UpgradeArrowIcon
                                    color={colors.blue}
                                    size={16}
                                    wrapWithDiv={false}
                                />
                            )}
                        </div>
                        <Body size='small' color='dark'>
                            {props.body}
                        </Body>
                    </Stack>
                    <Button
                        variant='primary'
                        size='small'
                        onClick={
                            props.requiresUpgrade
                                ? () => appHistory.push('/setup/billing/sales')
                                : props.onClick
                        }
                        fitContent={true}
                        disabled={props.requiresUpgrade ? false : !props.onClick}
                    >
                        {props.requiresUpgrade ? 'Upgrade' : 'Get started'}
                    </Button>
                </div>
            </div>
        </Card>
    );
}
